/**
 * index
 */
export * from './src/index';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-file-utils/index.js
// module id = 840
// module chunks = 0